module.exports = __webpack_public_path__ + "img/garage-drawer.976a9d58.jpg";